SEARCH_DEBOUNCE_INTERVAL = 350
LOAD_ON_SCROLL_FRACTION = 0.8

remainingPages = require 'utils/remaining-pages'

App.DishSelectSectionComponent = Em.Component.extend
  classNames: ['dish-select']

  # Services
  store: Em.inject.service('store')

  # Properties
  dishes: []
  categories: []
  filteredCategories: []
  restaurant: null
  focused: false
  isLoading: false
  processingRequests: 0
  page: 1
  pageCount: 1
  perPage: 10
  showButtonForOptionalModifiers: localStorage.getItem('showButtonForOptionalModifiers') == 'true'
  _pendingPromises: []
  _scrollHandler: null

  # Computed properties
  emptyQuery: Em.computed.empty('debouncedSearchQuery')

  debouncedSearchQuery: null
  debouncedSearchQueryTimeout: null

  formattedDishes: (->
    dishes = @get('dishes')
    items = @get('order').get('items')
    return dishes unless items
    
    dishes.sortBy('menu_order').map (dish) =>
      findedItem = items.find (item) =>
        item.get('dish.id') == dish.get('id')
      
      dish.set('amount', if findedItem then findedItem.get('amount') else null)

      if not Em.isEmpty(dish.get('options')) and @get('showButtonForOptionalModifiers')
        hasOptionalModifiers = dish.get('options').every (option) =>
          (option.get('view_type') == 'checkbox' or option.get('view_type') == 'stepper') and 
          (option.get('min') == 0 or not option.get('min'))

      dish.set('hasOptionalModifiers', hasOptionalModifiers)
      dish
  ).property('dishes.[]', 'dishes.@each', 'order.items.[]', 'order.items.@each')

  secondLevelCategories: Em.computed.filterBy('categories', 'is_root', false)
  hasTwoLevelCategories: Em.computed.notEmpty('secondLevelCategories')
  
  visibleCategories: (->
    return @get('rootCategories') if Em.isEmpty(@get('filteredCategory'))
    @get('filteredCategory.categories')
  ).property('rootCategories', 'categories', 'filteredCategory')

  filteredCategory: (->
    @get('filteredCategories')[@get('filteredCategories.length')-1]
  ).property('filteredCategories', 'filteredCategories.@each')

  rootCategories: Em.computed.filterBy('categories', 'is_root', true)

  showLoader: (->
    return false if @get('dishes.length') > 0
    @get('isLoading') || @get('processingRequests') > 0
  ).property('isLoading', 'processingRequests', 'dishes.length')

  # Lifecycle hooks
  init: ->
    @_super()
    @loadCategories()
    @set('_pendingPromises', [])
    @set('_scrollHandler', @onParentScroll.bind(@))
    @set('filteredCategories', [])

  willDestroyElement: ->
    # Cancel all pending promises
    @get('_pendingPromises').forEach (promise) =>
      promise.cancel?() if typeof promise.cancel == 'function'
    
    # Clear debounce timeout
    Em.run.cancel(@get('debouncedSearchQueryTimeout'))
    
    # Detach scroll handler
    @detachScrollHandler()
    
    # Clear references
    @set('_pendingPromises', [])
    @set('_scrollHandler', null)
    @set('filteredCategories', [])
    
    @_super()

  # Methods
  loadCategories: ->
    @get('store').find('category', {organization_id: @get('organization.id')})
      .then (categories) =>
        @set('categories', categories.sortBy('menu_order')) unless @get('isDestroyed')

  debounceSearchQuery: (->
    Em.run.cancel(@get('debouncedSearchQueryTimeout'))
    if Ember.isEmpty(@get('searchQuery'))
      @set('debouncedSearchQuery', '')
      return
    
    @set('debouncedSearchQueryTimeout', 
      Em.run.later(@, ->
        @set('debouncedSearchQuery', @get('searchQuery'))
        @set('debouncedSearchQueryTimeout', null)
      , 2000))
  ).observes('searchQuery')

  fetchDishPortion: ->
    return Em.RSVP.resolve() if @get('isDestroyed')
    
    component = this
    promise = new Em.RSVP.Promise (resolve, reject) =>
      return resolve() if component.get('isDestroyed')
      
      page = component.get('page')
      perPage = component.get('perPage')
      searchQuery = component.get('searchQuery')
      categoryId = component.get('filteredCategory.id')
      organization = component.get('organization')

      query = {
        page: page,
        per_page: perPage,
        organization_id: organization.get('id')
      }
      
      query.search = searchQuery if not Em.isBlank(searchQuery)
      query.category_id = categoryId if categoryId

      component.setProperties(
        isLoading: true,
        processingRequests: component.get('processingRequests') + 1
      )

      storePromise = component.get('store').find('dish', query)
      component.get('_pendingPromises').pushObject(storePromise)

      storePromise
        .then (dishes) ->
          return if component.get('isDestroyed')
          return if categoryId != component.get('filteredCategory.id')

          meta = dishes.get('meta')
          component.setProperties(
            page: meta.page,
            pageCount: meta.page_count
          )
          resolve(dishes)
        .catch(reject)
        .finally ->
          unless component.get('isDestroyed')
            component.setProperties(
              isLoading: false,
              processingRequests: Math.max(0, component.get('processingRequests') - 1)
            )
          component.get('_pendingPromises').removeObject(storePromise)

    promise.cancel = -> storePromise.cancel?()
    promise

  loadDishes: ->
    return if @get('isDestroyed') or @get('isLoading')
    
    @fetchDishPortion().then (dishes) =>
      return if @get('isDestroyed')
      
      @get('restaurant.availability')
      @set('dishes', dishes)
      
      Em.run.next =>
        @get('_scrollHandler')() unless @get('isDestroyed')

  loadMoreDishes: ->
    return if @get('isDestroyed') or @get('isLoading')
    return if Ember.isEmpty(@get('dishes'))
    return if @get('page') >= @get('pageCount')

    @incrementProperty('page')
    @fetchDishPortion().then (dishes) =>
      @get('dishes').pushObjects(dishes.get('content')) unless @get('isDestroyed')

  onParentScroll: (e) ->
    return if @get('isDestroyed')
    
    el = @$().parent()
    pages = remainingPages(el.get(0))
    
    @loadMoreDishes() if pages < LOAD_ON_SCROLL_FRACTION

  attachScrollHandler: (->
    return if @get('isDestroyed')
    @$()?.parent()?.on('scroll', @get('_scrollHandler'))
  ).on('didInsertElement')

  detachScrollHandler: (->
    return if @get('isDestroyed')
    @$()?.parent()?.off('scroll', @get('_scrollHandler'))
  ).on('willDestroyElement')

  showBalloon: (dish) ->
    return if @get('isDestroyed')
    
    $cont = @$(".dish-media-object[data-dish-id=#{dish.get('id')}]")
    $notifCont = $cont.find('.baloons')
    $notif = Em.$('<div>').addClass('baloon').text('блюдо добавлено')

    ANIM_DURATION = 800

    $notif.velocity({ scaleX: 0.5, scaleY: 0.5, opacity: 0.3}, { duration: 0})
    $notif.velocity({
      scaleX: '1.4',
      scaleY: '1.4'
    }, { duration: 800, easing: [250, 15], queue: false })

    $notif.velocity({ opacity: 1.0 }, {duration: 200, easing: 'easeOutCirc', queue: false })

    $notif.velocity({
      translateY: "-50px"
    }, {
      duration: ANIM_DURATION,
      queue: false,
      complete: => $notif.remove() unless @get('isDestroyed')
    })

    Em.run.later =>
      $notif.velocity({
        opacity: 0.0
      }, { duration: 400, queue: false }) unless @get('isDestroyed')
    , 300

    $notifCont.append($notif)
    false

  # Observers
  onFocusChanged: (->
    return if @get('isDestroyed')
    
    @setProperties(
      dishes: Em.A([]),
      page: 1,
      searchQuery: ''
    )

    if @get('focused')
      @get('searchInput')?.send('focus')
      @loadDishes()
  ).observes('focused')

  onQueryChanged: (->
    return unless @get('focused') and not @get('isDestroyed')
    
    @setProperties(
      page: 1,
      dishes: []
    )
    @loadDishes()
  ).observes('debouncedSearchQuery')

  onFilteredCategoryChanged: (->
    return if @get('isDestroyed')
    
    @setProperties(
      isLoading: false,
      page: 1,
      dishes: []
    )
    @loadDishes()
  ).observes('filteredCategory')

  updateAvailability: (->
    return if @get('isDestroyed')
    
    a = @get('restaurant.availability')
    @get('dishes').forEach (d) =>
      status = if a && a[d.get('id')] then a[d.get('id')] else {status: 'available'}
      d.set('restaurantAvailability', status) unless @get('isDestroyed')
  ).observes('restaurant', 'restaurant.availability', 'dishes', 'dishes.length')

  # Actions
  actions:
    loadMore: ->
      @loadMoreDishes()
      false

    selectDish: (dish, showConfigForOptionalModifiers) ->
      return if @get('isDestroyed')
      
      @sendAction('onDishSelect', dish, showConfigForOptionalModifiers)
      
      if @get('showButtonForOptionalModifiers')
        @showBalloon(dish) if Em.isEmpty(dish.get('options')) || dish.get('hasOptionalModifiers')
      else
        @showBalloon(dish) if Em.isEmpty(dish.get('options'))
      false

    selectCategory: (category) ->
      @get('filteredCategories').pushObject(category) unless @get('isDestroyed')
      false

    unSelectCategory: (category) ->
      return if @get('isDestroyed')
      
      removeCategory = (cat) =>
        @get('filteredCategories').removeObject(cat)
        cat.get('categories').forEach (subCat) => removeCategory(subCat)
      
      removeCategory(category)
      false

    cancel: ->
      @sendAction('onCancel') unless @get('isDestroyed')
      false